// extracted by mini-css-extract-plugin
export var container = "parking-reservation-info-table-module--container--lJXpz";
export var infoRow = "parking-reservation-info-table-module--infoRow--dMKec";
export var infoKeySection = "parking-reservation-info-table-module--infoKeySection--3_mm-";
export var infoValueSection = "parking-reservation-info-table-module--infoValueSection--2cI_r";
export var addressText = "parking-reservation-info-table-module--addressText--3NMt6";
export var feesRow = "parking-reservation-info-table-module--feesRow--3wucQ";
export var feesText = "parking-reservation-info-table-module--feesText--1za4n";
export var servicesText = "parking-reservation-info-table-module--servicesText--3MQ-l";